import React, { useEffect } from "react";
import { v4 as uuidv4 } from "uuid";
import CryptoJS from "crypto-js";
import { Box, Typography, CircularProgress } from "@mui/material";

const CommonAuthCallback = () => {
  useEffect(() => {
    const initiateTokenExchange = async () => {
      try {
        // Get callback_url from query parameters
        const urlParams = new URLSearchParams(window.location.search);
        const callbackUrl = urlParams.get("redirect");

        if (!callbackUrl) {
          console.error("callback_url parameter is missing");
          return;
        }

        // Generate random UUID code (code_verifier)
        const codeVerifier = uuidv4();

        // Hash the code with SHA256 (code_challenge)
        const codeChallenge = CryptoJS.SHA256(codeVerifier).toString(
          CryptoJS.enc.Hex,
        );

        console.log(codeVerifier, "codeVerifier");

        // Store code_verifier in sessionStorage for later use
        sessionStorage.setItem("code_verifier", codeVerifier);

        console.log(codeVerifier, "codeVerifier");

        // Prepare redirect URL with query parameters
        // const clientId = process.env.REACT_APP_CLIENT_ID;
        const clientId = "Amgen-Dash";

        const redirectUrl = new URL(callbackUrl);
        // redirectUrl.searchParams.set("client_id", "pace_bi");
        redirectUrl.searchParams.set("client_id", clientId);
        redirectUrl.searchParams.set("code_challenge", codeChallenge);
        redirectUrl.searchParams.set(
          "callback",
          window.location.origin + "/callback/authorize",
        );

        // Redirect to Agentic ACE frontend
        window.location.href = redirectUrl.toString();
      } catch (error) {
        console.error("Error during token exchange initiation:", error);
      }
    };

    initiateTokenExchange();
  }, []);

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        flexDirection: "column",
        gap: 3,
      }}
    >
      <CircularProgress size={60} />
      <Typography variant="h5" sx={{ fontWeight: 500 }}>
        Redirecting to authentication...
      </Typography>
      <Typography variant="body1" color="text.secondary">
        Please wait while we redirect you to Agentic ACE.
      </Typography>
    </Box>
  );
};

export default CommonAuthCallback;
